import { ExtraSortStatus, ModuleConfig, ModuleName } from '../types/module-config';
import BankActModule from '../views/home/bank-act-module/index.vue';
import BannerModule from '../views/home/banner-module/index.vue';
import CommonShareModule from '../views/home/common-share-module/index.vue';
import ECashCoupon from '../views/home/e-cash-coupon/index.vue';
import MainlandActModule from '../views/home/mainland-act-module/index.vue';
import NewUserModule from '../views/home/new-user-module/index.vue';
import ScanGiftModule from '../views/home/scan-gift-module/index.vue';
import ShareCouponModule from '../views/home/share-coupon-module/index.vue';
import WecouponModule from '../views/home/wecoupon-module/index.vue';
import WePointsModule from '../views/home/wepoints-module/index.vue';

/** 常驻模块的配置
 * 排序：商户信息模块 > 分享券模块 > 扫码券礼包模块 >
 * 迎新模块 > banner模块 > 港人内地活动模块 > 银行活动模块 > 电子现金券模块 > 抢券有SO模块 > 印花模块 > 分享指引模块
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const commonModuleConfig: Array<ModuleConfig> = [
  {
    moduleName: ModuleName.bankActModule,
    component: BankActModule,
    extraSort: ExtraSortStatus.common,
    sort: 78,
  },
  {
    moduleName: ModuleName.ShareCouponModule,
    component: ShareCouponModule,
    extraSort: ExtraSortStatus.common,
    sort: 90,
  },
  {
    moduleName: ModuleName.bannerModule,
    component: BannerModule,
    extraSort: ExtraSortStatus.common,
    sort: 80,
  },
  {
    moduleName: ModuleName.mainlandActModule,
    component: MainlandActModule,
    extraSort: ExtraSortStatus.common,
    sort: 79,
  },
  {
    moduleName: ModuleName.NewUserModule,
    component: NewUserModule,
    sort: 84,
    extraSort: ExtraSortStatus.common,
  },
  {
    moduleName: ModuleName.ScanGiftModule,  // 跟NewUserModule互斥
    component: ScanGiftModule,
    sort: 90,
    extraSort: ExtraSortStatus.common,
  },
  {
    moduleName: ModuleName.wePointsModule,
    component: WePointsModule,
    sort: 50,
  },
  {
    moduleName: ModuleName.weCouponModule,
    component: WecouponModule,
    sort: 60,
  },
  {
    moduleName: ModuleName.commonShareModule,
    component: CommonShareModule,
    sort: 0,
  },
  {
    moduleName: ModuleName.ECashCoupon,
    component: ECashCoupon,
    sort: 70,
  },
];

